const schoolStaffRoutes = [
  // Admission Management Routes
  {
    path: '/school/admission',
    name: 'Admission Management',
    component: () => import('@/views/PortalSchool/AdmissionManagement/Index.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/admission/online-admission',
    name: 'Online Admission',
    component: () => import('@/views/PortalSchool/AdmissionManagement/Pages/Admission.vue'),
    meta: { user: 'SchoolStaff' }
  },


  //Student Information System Routes
  {
    path: '/school/student-information-system',
    name: 'Student Information System',
    component: () => import('@/views/PortalSchool/StudentInformationSystem/Index.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/student-information-system/student-profile',
    name: 'Student Profile',
    component: () => import('@/views/PortalSchool/StudentInformationSystem/Pages/StudentProfile.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/student-information-system/student-promotion',
    name: 'Student Promotion',
    component: () => import('@/views/PortalSchool/StudentInformationSystem/Pages/StudentPromotion.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/student-information-system/alumni-management',
    name: 'Alumni Management',
    component: () => import('@/views/PortalSchool/StudentInformationSystem/Pages/AlumniManagement.vue'),
    meta: { user: 'SchoolStaff' }
  },

  //Staff Management
  {
    path: '/school/staff-management',
    name: 'Staff Management',
    component: () => import('@/views/PortalSchool/StaffManagement/Index.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/staff-management/staff-profile',
    name: 'Staff Profile',
    component: () => import('@/views/PortalSchool/StaffManagement/Pages/StaffProfile.vue'),
    meta: { user: 'SchoolStaff' }
  },


  // Academic Management Routes
  {
    path: '/school/academic-management',
    name: 'Academic Management',
    component: () => import('@/views/PortalSchool/AcademicManagement/Index.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/academic-management/academic-sessions',
    name: 'Academic Sessions',
    component: () => import('@/views/PortalSchool/AcademicManagement/Pages/AcademicSession.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/academic-management/terms',
    name: 'Terms',
    component: () => import('@/views/PortalSchool/AcademicManagement/Pages/Terms.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/academic-management/classes',
    name: 'Classes',
    component: () => import('@/views/PortalSchool/AcademicManagement/Pages/Classes.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/academic-management/options',
    name: 'Options',
    component: () => import('@/views/PortalSchool/AcademicManagement/Pages/Options.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/academic-management/arms',
    name: 'Arms',
    component: () => import('@/views/PortalSchool/AcademicManagement/Pages/Arms.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/academic-management/subjects',
    name: 'Subjects',
    component: () => import('@/views/PortalSchool/AcademicManagement/Pages/Subjects.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/academic-management/psycomotor-skills',
    name: 'Psycomotor Skills',
    component: () => import('@/views/PortalSchool/AcademicManagement/Pages/PsycomotorSkills.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/academic-management/conduct',
    name: 'Conduct',
    component: () => import('@/views/PortalSchool/AcademicManagement/Pages/Conduct.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/academic-management/grade-scale',
    name: 'Grade Scale',
    component: () => import('@/views/PortalSchool/AcademicManagement/Pages/GradeScale.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/academic-management/mock-exam',
    name: 'Mock Exam',
    component: () => import('@/views/PortalSchool/AcademicManagement/Pages/MockExam.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/academic-management/mock-exam-subjects',
    name: 'Mock Exam Subjects',
    component: () => import('@/views/PortalSchool/AcademicManagement/Pages/MockExamSubjects.vue'),
    meta: { user: 'SchoolStaff' }
  },


  // Timetable Management Routes
  {
    path: '/school/timetable-management',
    name: 'Timetable Management',
    component: () => import('@/views/PortalSchool/TimetableManagement/Index.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/timetable-management/timetable',
    name: 'TimeTable',
    component: () => import('@/views/PortalSchool/TimetableManagement/Pages/TimeTable.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/timetable-management/timetable-view',
    name: 'TimeTable View',
    component: () =>
      import('@/views/PortalSchool/TimetableManagement/Pages/TimeTableDetails.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/timetable-management/timetable-break',
    name: 'Time Table Break',
    component: () =>
      import('@/views/PortalSchool/TimetableManagement/Pages/TimeTableBreak.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/timetable-management/timetable-timeslot',
    name: 'Time Table Time Slot',
    component: () =>
      import('@/views/PortalSchool/TimetableManagement/Pages/TimeTableTimeSlot.vue'),
    meta: { user: 'SchoolStaff' }
  },




  //Attendance Management Routes
  {
    path: '/school/attendance-management',
    name: 'Attendance Management',
    component: () => import('@/views/PortalSchool/AttendanceManagement/Index.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/attendance-management/student-attendance',
    name: 'Student Attendance',
    component: () =>
      import('@/views/PortalSchool/AttendanceManagement/Pages/StudentAttendance.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/attendance-management/student-sign-in-sign-out',
    name: 'Student Sign In/Sign Out Attendance',
    component: () =>
      import('@/views/PortalSchool/AttendanceManagement/Pages/StudentSignInSignOut.vue'),
    meta: { user: 'SchoolStaff' }
  },



  // Learning Management 
  {
    path: '/school/learning-management',
    name: 'Learning Management',
    component: () => import('@/views/PortalSchool/LearningManagement/Index.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/learning-management/class-notes',
    name: 'Class Notes',
    component: () =>
      import('@/views/PortalSchool/LearningManagement/Pages/ClassNotes.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/learning-management/lesson-plans',
    name: 'Lesson Plans',
    component: () =>
      import('@/views/PortalSchool/LearningManagement/Pages/LessonPlans.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/learning-management/assignments',
    name: 'Assignments',
    component: () =>
      import('@/views/PortalSchool/LearningManagement/Pages/Assignments.vue'),
    meta: { user: 'SchoolStaff' }
  },



  // Examination and Assessment Routes
  {
    path: '/school/examination-and-assessment',
    name: 'Examination and Assessment',
    component: () => import('@/views/PortalSchool/ExaminationAndAssessment/Index.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/examination-and-assessment/cbt-exams',
    name: 'CBT Exams',
    component: () =>
      import('@/views/PortalSchool/ExaminationAndAssessment/Pages/CBTExamSetup/CbtExams.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/examination-and-assessment/cbt-exam-others',
    name: 'Other CBT Exams',
    component: () =>
      import('@/views/PortalSchool/ExaminationAndAssessment/Pages/CBTExamSetup/CbtExamOthers.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/examination-and-assessment/cbt-questions',
    name: 'CBT Questions',
    component: () =>
      import('@/views/PortalSchool/ExaminationAndAssessment/Pages/CBTExamSetup/CbtQuestions.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/examination-and-assessment/cbt-question-others',
    name: 'CBT Questions Others',
    component: () =>
      import('@/views/PortalSchool/ExaminationAndAssessment/Pages/CBTExamSetup/CbtQuestionOthers.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/examination-and-assessment/cbt-answers',
    name: 'CBT Answers',
    component: () =>
      import('@/views/PortalSchool/ExaminationAndAssessment/Pages/CBTExamSetup/CbtAnswers.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/examination-and-assessment/mark-record',
    name: 'Mark Record',
    component: () =>
      import('@/views/PortalSchool/ExaminationAndAssessment/Pages/MarkRecord/Index.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/examination-and-assessment/class-attendance-record',
    name: 'Class Attendance Record',
    component: () =>
      import('@/views/PortalSchool/ExaminationAndAssessment/Pages/ClassAttendance/Index.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/examination-and-assessment/conduct-assessment',
    name: 'Conduct Assessment',
    component: () =>
      import('@/views/PortalSchool/ExaminationAndAssessment/Pages/ConductAssesment/Index.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/examination-and-assessment/psycomotor-skills-assessment',
    name: 'Psycomotor Skills Assessment',
    component: () =>
      import('@/views/PortalSchool/ExaminationAndAssessment/Pages/PsycomotorSkillsAssement/Index.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/examination-and-assessment/physical-development-assessment',
    name: 'Physical Development Assessment',
    component: () =>
      import('@/views/PortalSchool/ExaminationAndAssessment/Pages/PhysicalDevelopmentAssessment/Index.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/examination-and-assessment/mock-record',
    name: 'Mock Record',
    component: () =>
      import('@/views/PortalSchool/ExaminationAndAssessment/Pages/MockRecord.vue'),
    meta: { user: 'SchoolStaff' }
  },



  //Finance Management Routes
  {
    path: '/school/finance-management',
    name: 'Finance Management',
    component: () => import('@/views/PortalSchool/FinanceManagement/Index.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/finance-management/fee-structure',
    name: 'Fee Structure',
    component: () =>
      import('@/views/PortalSchool/FinanceManagement/Pages/FeeStructure.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/finance-management/bill-payment',
    name: 'Bill Payment',
    component: () =>
      import('@/views/PortalSchool/FinanceManagement/Pages/BillPayment.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/finance-management/income',
    name: 'Income',
    component: () =>
      import('@/views/PortalSchool/FinanceManagement/Pages/Income.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/finance-management/expenses',
    name: 'Expenses',
    component: () =>
      import('@/views/PortalSchool/FinanceManagement/Pages/Expenses.vue'),
    meta: { user: 'SchoolStaff' }
  },



  // Library Management Routes
  {
    path: '/school/library-management',
    name: 'Library Management',
    component: () => import('@/views/PortalSchool/LibraryManagement/Index.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/library-management/books',
    name: 'Books',
    component: () =>
      import('@/views/PortalSchool/LibraryManagement/Pages/Books.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/library-management/book-borrowing',
    name: 'Book Borrowing',
    component: () =>
      import('@/views/PortalSchool/LibraryManagement/Pages/BookBorrowing.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/library-management/book-returns',
    name: 'Book Returns',
    component: () =>
      import('@/views/PortalSchool/LibraryManagement/Pages/BookReturns.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/library-management/book-stock-summary',
    name: 'Book Stock Summary',
    component: () =>
      import('@/views/PortalSchool/LibraryManagement/Pages/BookStockSummary.vue'),
    meta: { user: 'SchoolStaff' }
  },





  // Hostel Management Routes
  {
    path: '/school/hostel-management',
    name: 'Hostel Management',
    component: () => import('@/views/PortalSchool/HostelManagement/Index.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/hostel-management/hostels',
    name: 'Hostels',
    component: () =>
      import('@/views/PortalSchool/HostelManagement/Pages/Hostels.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/hostel-management/hostel-floors',
    name: 'Hostel Floors',
    component: () =>
      import('@/views/PortalSchool/HostelManagement/Pages/HostelFloors.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/hostel-management/hostel-rooms',
    name: 'Hostel Rooms',
    component: () =>
      import('@/views/PortalSchool/HostelManagement/Pages/HostelRooms.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/hostel-management/hostel-beds',
    name: 'Hostel Beds',
    component: () =>
      import('@/views/PortalSchool/HostelManagement/Pages/HostelBeds.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/hostel-management/bed-allocations',
    name: 'Bed Allocations',
    component: () =>
      import('@/views/PortalSchool/HostelManagement/Pages/BedAllocations.vue'),
    meta: { user: 'SchoolStaff' }
  },





  // Transport Management Routes
  {
    path: '/school/transport-management',
    name: 'Transport Management',
    component: () => import('@/views/PortalSchool/TransportManagement/Index.vue'),
    meta: { user: 'SchoolStaff' }
  },

  // Inventory and Assets Routes
  {
    path: '/school/inventory-and-assets',
    name: 'Inventory and Assets',
    component: () => import('@/views/PortalSchool/InventoryAndAssets/Index.vue'),
    meta: { user: 'SchoolStaff' }
  },

  // Communication Routes
  {
    path: '/school/communication',
    name: 'Communication',
    component: () => import('@/views/PortalSchool/Communication/Index.vue'),
    meta: { user: 'SchoolStaff' }
  },

  // Discipline Management Routes
  {
    path: '/school/discipline-management',
    name: 'Discipline Management',
    component: () => import('@/views/PortalSchool/DisciplineManagement/Index.vue'),
    meta: { user: 'SchoolStaff' }
  },

  //Health and Safety Routes
  {
    path: '/school/health-management',
    name: 'Health and Safety',
    component: () => import('@/views/PortalSchool/HealthManagement/Index.vue'),
    meta: { user: 'SchoolStaff' }
  },

  // Career and Guidance Routes
  {
    path: '/school/career-and-guidance',
    name: 'Career and Guidance',
    component: () => import('@/views/PortalSchool/CareerAndGuidance/Index.vue'),
    meta: { user: 'SchoolStaff' }
  },

  // Events Management Routes
  {
    path: '/school/events-management',
    name: 'Events Management',
    component: () => import('@/views/PortalSchool/EventsManagement/Index.vue'),
    meta: { user: 'SchoolStaff' }
  },

  // Certificates Routes
  {
    path: '/school/certificates',
    name: 'Certificates',
    component: () => import('@/views/PortalSchool/Certificates/Index.vue'),
    meta: { user: 'SchoolStaff' }
  },

  // Document Management Routes
  {
    path: '/school/document-management',
    name: 'Document Management',
    component: () => import('@/views/PortalSchool/DocumentManagement/Index.vue'),
    meta: { user: 'SchoolStaff' }
  },

  // Reports and Analytics Routes
  {
    path: '/school/reports-and-analytics',
    name: 'Reports and Analytics',
    component: () => import('@/views/PortalSchool/ReportsAndAnalytics/Index.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/reports-and-analytics/report-cards',
    name: 'Report Cards',
    component: () =>
      import('@/views/PortalSchool/ReportsAndAnalytics/Pages/ReportCard/Index.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/reports-and-analytics/broadsheet',
    name: 'Broadsheet',
    component: () =>
      import('@/views/PortalSchool/ReportsAndAnalytics/Pages/BroadSheet/Index.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/reports-and-analytics/broadsheet-per-position',
    name: 'Broad Sheet Per Position',
    component: () =>
      import('@/views/PortalSchool/ReportsAndAnalytics/Pages/BroadSheetPerPosition/Index.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/reports-and-analytics/mock-report',
    name: 'Mock Report Card',
    component: () =>
      import('@/views/PortalSchool/ReportsAndAnalytics/Pages/MockReport.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/reports-and-analytics/financial-report',
    name: 'Financial Report',
    component: () =>
      import('@/views/PortalSchool/ReportsAndAnalytics/Pages/FinancialReport.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/reports-and-analytics/class-attendance-report',
    name: 'Class Attendance Report',
    component: () =>
      import('@/views/PortalSchool/ReportsAndAnalytics/Pages/ClassAttendanceReport.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/reports-and-analytics/class-performing-ranking',
    name: 'Class Performing Ranking',
    component: () =>
      import('@/views/PortalSchool/ReportsAndAnalytics/Pages/ClassPerformingRanking.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/reports-and-analytics/student-account-statement',
    name: 'Student Account Statement',
    component: () =>
      import('@/views/PortalSchool/ReportsAndAnalytics/Pages/StudentAccountStatementReport.vue'),
    meta: { user: 'SchoolStaff' }
  },






  // School Website Routes
  {
    path: '/school/school-website',
    name: 'School Website',
    component: () => import('@/views/PortalSchool/SchoolWebsite/Index.vue'),
    meta: { user: 'SchoolStaff' }
  },

  // School Details Routes
  {
    path: '/school/school-details',
    name: 'School Details',
    component: () => import('@/views/PortalSchool/SchoolDetails.vue'),
    meta: { user: 'SchoolStaff' }
  },


  {
    path: '/school/subscription',
    name: 'Subscription',
    component: () =>
      import('@/views/PortalSchool/Subscription/Index.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/subscription/portal-subscription',
    name: 'School Portal Subscription',
    component: () =>
      import('@/views/PortalSchool/Subscription/Component/PortalSubscription.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/subscription/portal-subscription-verify',
    name: 'School Portal Subscription Verify',
    component: () =>
      import('@/views/PortalPaymentConfirmation.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/cbt-report-card-subscription',
    name: 'School CBT & Report Subscription',
    component: () =>
      import('@/views/PortalSchool/Subscription/Component/ReportcardandCbt.vue'),
    meta: { user: 'SchoolStaff' }
  },
  {
    path: '/school/sms-subscription',
    name: 'School SMS Subscription',
    component: () =>
      import('@/views/PortalSchool/Subscription/Component/Sms.vue'),
    meta: { user: 'SchoolStaff' }
  },


]

export default schoolStaffRoutes
